import { render, staticRenderFns } from "./LicenciasLista.vue?vue&type=template&id=136c6378&scoped=true"
import script from "./LicenciasLista.vue?vue&type=script&lang=js"
export * from "./LicenciasLista.vue?vue&type=script&lang=js"
import style0 from "./LicenciasLista.vue?vue&type=style&index=0&id=136c6378&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136c6378",
  null
  
)

export default component.exports